import { useTranslation } from 'react-i18next';
import type { PlaylistListRowModel } from './buildPlaylistListModel';

type PlaylistListRowProps = {
  row: PlaylistListRowModel;
  onOpen: (playlistId: string) => void;
};

export function PlaylistListRow({ row, onOpen }: PlaylistListRowProps) {
  const { t } = useTranslation('playlists');
  return (
    <button
      type="button"
      onClick={() => onOpen(row.playlist.id)}
      className="flex w-full flex-wrap items-center gap-x-5 gap-y-3 border-b px-5 py-[17px] text-start transition last:border-b-0 hover:bg-[var(--gs-panel2)]"
      style={{ borderColor: 'var(--gs-line)', color: 'var(--gs-ink)' }}
    >
      <span
        className="grid h-[42px] w-[42px] shrink-0 place-items-center rounded-[10px] border"
        style={{
          background: 'var(--gs-panel2)',
          borderColor: 'var(--gs-line)',
          color: 'var(--gs-accent)',
        }}
        aria-hidden
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <path d="M4 6h11M4 12h11M4 18h7" />
          <path d="m17 12 5 3-5 3z" fill="currentColor" stroke="none" />
        </svg>
      </span>

      <span className="flex min-w-[160px] flex-1 flex-col gap-1">
        <span className="text-[15.5px] font-bold">{row.name}</span>
        <span className="text-[12.5px]" style={{ color: 'var(--gs-muted)' }}>
          {row.meta}
        </span>
      </span>

      <span
        className="rounded-full border px-[11px] py-[5px] text-[12.5px] font-semibold"
        style={{
          color: 'var(--gs-ink2)',
          background: 'var(--gs-panel2)',
          borderColor: 'var(--gs-line)',
        }}
      >
        {row.screensLabel}
      </span>

      <span className="min-w-[92px] text-[13px]" style={{ color: 'var(--gs-muted)' }}>
        {row.durationLabel}
      </span>

      <span className="text-[13px] font-bold" style={{ color: 'var(--gs-accent)' }}>
        {t('row.edit')}
      </span>
    </button>
  );
}
